import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BottomNav } from "@/components/Nav";

function today() { return new Date().toISOString().slice(0,10); }

export default function Workouts() {
  const [plans, setPlans] = useState([]);
  const [logs, setLogs] = useState([]);
  const [week, setWeek] = useState(1);
  const [form, setForm] = useState({ date: today(), title: "", type: "strength", duration_min: 30, steps: 0, notes: "" });

  const load = async () => {
    const [p, l] = await Promise.all([api.get("/workouts/plan"), api.get("/workouts/log")]);
    setPlans(p.data); setLogs(l.data);
  };
  useEffect(() => { load(); }, []);

  const log = async (e) => {
    e.preventDefault();
    await api.post("/workouts/log", form);
    setForm({ ...form, title: "", notes: "" });
    load();
  };

  const weekPlans = plans.filter(p=>p.week===week);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white safe-pb">
      <div className="max-w-xl mx-auto px-4 pt-6">
        <h1 className="font-display font-black uppercase text-3xl tracking-tighter">Training</h1>

        <div className="flex gap-2 overflow-x-auto mt-4 pb-2">
          {Array.from({length: 12}).map((_,i)=>(
            <button key={i} onClick={()=>setWeek(i+1)} className={`shrink-0 px-3 py-1.5 border uppercase text-xs tracking-widest ${week===i+1?"border-gold text-gold":"border-[#333] text-neutral-400"}`} data-testid={`week-${i+1}`}>W{i+1}</button>
          ))}
        </div>

        <div className="kw-card p-4 mt-3">
          <div className="text-xs uppercase tracking-widest text-neutral-500">Week {week} plan</div>
          {weekPlans.length===0 && <div className="text-sm text-neutral-500 mt-2">No plan yet. Your coach will set it.</div>}
          <div className="mt-3 space-y-3">
            {weekPlans.map((p) => (
              <div key={`${p.week}-${p.day}`} className="border border-[#262626] p-3" data-testid={`plan-${p.week}-${p.day}`}>
                <div className="flex items-center justify-between">
                  <div className="font-display font-bold uppercase tracking-tight">{p.title}</div>
                  <div className="text-[10px] uppercase tracking-widest text-gold">Day {p.day} · {p.type}</div>
                </div>
                {p.exercises?.length>0 && (
                  <ul className="mt-2 space-y-1 text-sm text-neutral-300">
                    {p.exercises.map((e,i)=>(
                      <li key={i} className="flex justify-between"><span>{e.name}</span><span className="text-neutral-500">{e.sets}×{e.reps}</span></li>
                    ))}
                  </ul>
                )}
                {p.notes && <div className="text-xs text-neutral-500 mt-2">{p.notes}</div>}
              </div>
            ))}
          </div>
        </div>

        <form onSubmit={log} className="kw-card p-4 mt-5">
          <div className="text-xs uppercase tracking-widest text-neutral-500 mb-3">Log a session</div>
          <div className="grid grid-cols-2 gap-2">
            <input className="kw-input" type="date" value={form.date} onChange={e=>setForm({...form,date:e.target.value})} data-testid="log-date"/>
            <select className="kw-input" value={form.type} onChange={e=>setForm({...form,type:e.target.value})} data-testid="log-type">
              <option value="strength">Strength</option>
              <option value="cardio">Cardio</option>
              <option value="walking">Walking</option>
              <option value="recovery">Recovery</option>
            </select>
          </div>
          <input className="kw-input mt-2" placeholder="Title (e.g. Full body A)" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} required data-testid="log-title"/>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <input className="kw-input" type="number" placeholder="Duration (min)" value={form.duration_min} onChange={e=>setForm({...form,duration_min:parseInt(e.target.value||"0")})} data-testid="log-duration"/>
            <input className="kw-input" type="number" placeholder="Steps" value={form.steps} onChange={e=>setForm({...form,steps:parseInt(e.target.value||"0")})} data-testid="log-steps"/>
          </div>
          <textarea className="kw-input mt-2" rows={2} placeholder="Notes" value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} data-testid="log-notes"/>
          <button className="kw-btn-primary w-full mt-3" data-testid="log-submit">Log session</button>
        </form>

        <div className="mt-5 space-y-2">
          <div className="text-xs uppercase tracking-widest text-neutral-500">Recent sessions</div>
          {logs.slice(0,8).map(l => (
            <div key={l.id} className="kw-card p-3 flex justify-between">
              <div>
                <div className="text-sm font-semibold">{l.title}</div>
                <div className="text-xs text-neutral-500">{l.date} · {l.type} · {l.duration_min||0} min {l.steps?`· ${l.steps} steps`:""}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
